import {createApi} from '@reduxjs/toolkit/query/react'
import api from 'services/api'
import axios from 'axios'
// import storage from 'services/storage'

export const transformResponseFromData = (response) => {
    // console.log({response}, 'transform response')
    if (response.error) {
        throw response.error
    }
    return response
}
export const transformResponseFromMessage = (response) => response.message

export const provideTags = (tagName, data, tagField) => {
    return data
        ? [
              ...data?.data?.map((item) => ({
                  type: tagName,
                  id: item[tagField || '_id'],
              })),
              {type: tagName, id: 'LIST'},
          ]
        : [{type: tagName, id: 'LIST'}]
}
export const provideTag = (tagName, data, tagField) => {
    return data
        ? [{type: tagName, id: data[tagField || '_id']}]
        : [{type: tagName, id: 'LIST'}]
}

const sendAxiosRequest = (baseUrl, url, method, body, headers) =>
    axios({
        url: `${baseUrl}/${url}`,
        method,
        data: body,
        withCredentials: true,
        ...(headers && {headers: headers({})}),
    })

const axiosBaseQuery =
    ({baseUrl, headers} = {baseUrl: '', headers: ''}) =>
    async ({url, method, body}) => {
        // console.log('axios basic query', `${baseUrl}/${url}`, method, headers)
        try {
            const result = await sendAxiosRequest(
                baseUrl,
                url,
                method,
                body,
                headers
            )
            return {data: result.data}
        } catch (axiosError) {
            const responseError = {
                // data: err.response?.data,
                error: {
                    status: axiosError.response?.status,
                    data: axiosError.response?.data,
                },
            }

            // handle refresh
            if (
                axiosError.response?.status === 401 &&
                url !== 'auth/refreshToken'
            ) {
                try {
                    console.log('requesting refresh')
                    const refreshResult = await sendAxiosRequest(
                        baseUrl,
                        'auth/refreshToken',
                        method,
                        body,
                        headers
                    )
                    console.log('refresh result', refreshResult)

                    const result = await sendAxiosRequest(
                        baseUrl,
                        url,
                        method,
                        body,
                        headers
                    )
                    return {data: result.data}
                } catch (refreshError) {
                    console.log('refresh error', refreshError, responseError)
                    return responseError
                }
            }

            console.log('axios error', responseError)
            return responseError
        }
    }

const getHeaders = () => {
    return {
        Accept: 'application/json',
    }
}

const baseApi = createApi({
    baseQuery: axiosBaseQuery({
        baseUrl: api.baseUrl,
        headers: () => getHeaders(),
    }),
    reducerPath: 'api',
    tagTypes: [
        'CurrentUser',
        'Account',
        'User',
        'Dance',
        'Media',
        'Profile',
        'Organization',
    ],
    endpoints: () => ({}),
})

export default baseApi
